<template>
  <transition appear name="fade">
    <div class="background" :class="[ slideshow.currentSlide.person ]">
      <div class="logo" />
      <div class="titleBlock">
        <div class="title">{{ slideshow.currentSlide.title }}</div>
      </div>
      <div class="footer">Confidential / {{ slideshow.frontMatter.title }} / {{ slideshow.currentSlideIndex }}</div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SectionTitleFrame',
  components: {},
  props: {
    slideshow: Object,
  },
};
</script>

<style lang="scss" scoped>
.background {
  &.man1 {
    background-image: url("./images/avalia-man-1.jpg");
  }

  &.man2 {
    background-image: url("./images/avalia-man-2.jpg");
  }

  &.man3 {
    background-image: url("./images/avalia-man-3.jpg");
  }

  &.woman1 {
    background-image: url("./images/avalia-woman-1.jpg");
  }

  &.woman2 {
    background-image: url("./images/avalia-woman-2.jpg");
  }

  &.woman3 {
    background-image: url("./images/avalia-woman-3.jpg");
  }

  background-color: black;
  position: absolute;
  height: 100%;
  width: 100%;
  background-image: url("./images/avalia-woman-1.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: white;

  .logo {
    height: 4.5rem;
    margin-top: 2rem;
    margin-left: 2rem;
    background-image: url("./images/avalia-logo-white.png");
    background-repeat: no-repeat;
    background-size: contain;
  }

  .titleBlock {
    margin-top: -20%;
    margin-left: 40%;
    font-size: 4rem;
    font-weight: 100;
    line-height: normal;

    .title {
      color: white;
      font-size: 6rem;
      text-transform: uppercase;
      font-weight: 600;
    }
  }

  .footer {
    text-align: right;
    margin: 1rem;
    text-transform: uppercase;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

</style>
